import React from 'react'
import { connect } from 'react-redux'
import { Modal, ErrorBoundary } from 'components'
import { getPlanParams } from 'store/selectors'

function getCSRFToken() {
  var cookieValue = null
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';')
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim()
      if (cookie.substring(0, 10) === 'csrftoken=') {
        cookieValue = decodeURIComponent(cookie.substring(10))
        break
      }
    }
  }
  return cookieValue
}

function SaveDraft(props) {
  const handleSubmit = () => {
    const id = window.CLIENT_ID === '{{pms_user_id}}' ? 174 : window.CLIENT_ID
    fetch(`https://backoffice.capitalmind.in/api/goals/draft/store/${id}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCSRFToken(),
      },
      body: JSON.stringify({
        ...props.planParams,
        share_id: props.share_id,
      }),
    })
      .then(res => {
        alert(
          JSON.stringify(
            {
              status: res.status,
              statusText: res.statusText,
            },
            null,
            2
          )
        )
      })
      .catch(err => {
        alert(JSON.stringify(err, null, 2))
      })
  }

  return (
    <Modal
      title="Save Draft of Updated Plan"
      handleClose={() => props.history.replace('/plan')}
    >
      <div className="save-draft">
        <ErrorBoundary>
          <div>Preview</div>
          <pre>
            {JSON.stringify(
              { share_id: props.share_id, ...props.planParams },
              null,
              2
            )}
          </pre>
          <button onClick={handleSubmit}>Submit</button>
        </ErrorBoundary>
      </div>
    </Modal>
  )
}

export default connect(state => ({
  planParams: getPlanParams(state),
  share_id: state.session.share_id,
}))(SaveDraft)



// WEBPACK FOOTER //
// ./src/components/modals/SaveDraft.js